import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useEffect } from 'react';
import { Direction } from './types.js';

function keepInBounds(value, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  return Math.max(min, Math.min(max, value));
}
function getDirection(delta) {
  if (delta < 0) return Direction.Back;else if (delta > 0) return Direction.Forward;
  return Direction.Rest;
}
var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export { getDirection, keepInBounds, usePrevious };
